export default __webpack_public_path__ + "static/media/revealed4.426ec7bd.png";